<script lang="ts">
  import { createEventDispatcher } from 'svelte';

  export let showModal: boolean = false;
  export let isPromo: boolean = false;
  export let showTransactions: boolean = false;
  export let showEditBill: boolean = false;
  export let showAddBill: boolean = false;

  const dispatch = createEventDispatcher();
  const isVisible = (): boolean => showModal || showTransactions || showEditBill || showAddBill;

  const handleKeydown = (e: KeyboardEvent): void => {
    if (e.key === 'Escape' && isVisible()) dispatch('close');
  };
</script>

<svelte:window on:keydown={handleKeydown} />

{#if showModal || showTransactions || showEditBill || showAddBill}
  <div class="backdrop" class:promo={isPromo} on:click|self>
    <div class="modal {showTransactions ? 'transmodal' : ''}">
      <slot></slot>
    </div>
  </div>
{/if}

<style>
  .backdrop{
    width: 100%;
    height: 100%;
    position: fixed;
    background: rgba(0,0,0,0.8);
  }
  .modal{
    padding: 10px;
    border-radius: 10px;
    max-width: 400px;
    margin: 10% auto;;
    text-align: center;
    background: white;
  }
  .transmodal{
    max-width: 650px;
  }
  .promo .modal{
    background: crimson;
    color: white;
  }
</style>